import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from './fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('code'),
	fieldsMap.get('date'),
	fieldsMap.get('status'),
	fieldsMap.get('total'),
	fieldsMap.get('payment_code')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;